<template>
	<div style="min-height: 250;">
		<div v-if="list.length > 0">
			<a-button
				v-for="(g, index) in list"
				icon="delete"
				type="dashed"
				:key="index"
				:loading="g.isDeleting"
				@click="handleDelete(g)"
				class="mr-2 mb-2 btn-outline-danger"
			>
				{{ g.name }}
			</a-button>
		</div>
		<div v-else>
			<a-alert message="No group available" type="warning" />
		</div>
	</div>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'AccountGroupDelete',
	data: function() {
		return {}
	},
	methods: {
		handleDelete(group) {
			group.isDeleting = true
			this.deleteAccountGroup({ id: group.id }).then(() => {})
		},
		...mapActions({
			deleteAccountGroup: ACTIONS.ACCOUNT_GROUP.DELETE,
		}),
	},
	computed: {
		list() {
			return this.getAccountGroups.map(g => {
				g.isDeleting = false
				return g
			})
		},
		...mapGetters(['getAccountGroups']),
	},
}
</script>

<style></style>
